// Faz 5 — Ana sayfa varsayılan içerik (CMS yayınlanmamışsa bugünkü sayfa birebir bu değerlerle çizilir).
export const DEFAULT_HOME = {
  sections_order: ["hero", "pillars", "categories", "featured"],
  hero: {
    badge_text: "Türkiye'nin Yol Yardım ve Taşıma Ağı",
    title: "Yolda kaldığında veya\ntaşıman gerektiğinde",
    title_highlight: "Yol Hattı yanında.",
    subtitle: "Oto kurtarma, yol yardım, ağır vasıta kurtarma, lowbed, araç ve iş makinesi taşıma. Türkiye genelinde onaylı hizmet sağlayıcılar.",
    background_image_url: "",
    cta_text: "",
    cta_link: "",
  },
  pillars: {
    visible: true,
    items: [
      { key: "emergency", visible: true, title: "ACİL YOL YARDIM", description: "Yakındaki hattaki kurtarıcıları bul", cta_text: "Şimdi başla" },
      { key: "transport", visible: true, title: "TAŞIMA YAPTIR", description: "Araç veya iş makinesi taşıt", cta_text: "Talep Oluştur" },
      { key: "return", visible: true, title: "BOŞ DÖNÜŞ", description: "Müsait taşıyıcıları bul", cta_text: "Ara" },
    ],
  },
  categories: { visible: true, title: "Hizmet Kategorileri", subtitle: "" },
  featured: { visible: true, title: "Öne Çıkan Hizmet Sağlayıcılar", subtitle: "Bu bölüm genel işletme rehberi kayıtlarını gösterir; canlı GPS içermez.", max_items: 12 },
  blocks: [],
  seo: { title: "", description: "", og_image_url: "" },
};

export const CORE_KEYS = ["hero", "pillars", "categories", "featured"];
export const BLOCK_TYPE_LABELS = { faq: "SSS (soru-cevap)", stats: "İstatistik / sayaç", columns: "Sütunlu içerik", ad: "Reklam / banner" };

const newId = () => Math.random().toString(36).slice(2, 10).padEnd(8, "0");
export const newBlock = (type) => {
  const base = { id: newId(), type, visible: true };
  if (type === "faq") return { ...base, title: "Sıkça Sorulan Sorular", subtitle: "", items: [{ q: "", a: "" }] };
  if (type === "stats") return { ...base, title: "", subtitle: "", items: [{ value: "", label: "" }] };
  if (type === "columns") return { ...base, title: "", subtitle: "", columns: [{ html: "" }, { html: "" }] };
  return { ...base, label: "", image_url: "", alt_text: "", link_url: "", start_date: "", end_date: "" };
};

export const sectionLabel = (key, blocks) => {
  if (SECTION_LABELS[key]) return SECTION_LABELS[key];
  const b = blocks.find((x) => x.id === key);
  if (!b) return key;
  const name = b.type === "ad" ? b.label : b.title;
  return `${BLOCK_TYPE_LABELS[b.type]}${name ? ` · ${name}` : ""}`;
};

export const SECTION_LABELS = { hero: "Hero (karşılama alanı)", pillars: "Avantaj kartları", categories: "Hizmet kategorileri", featured: "Öne çıkan işletmeler" };

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

// Keep only fields whose type matches the default (malformed data never reaches the renderer).
const pick = (def, val) => {
  if (!isObj(val)) return def;
  const out = { ...def };
  Object.keys(def).forEach((k) => {
    if (k === "items") return;
    if (typeof val[k] === typeof def[k]) out[k] = val[k];
  });
  return out;
};

// Defensive merge: missing/invalid published data falls back to defaults field by field.
export const mergeHome = (pub) => {
  if (!isObj(pub)) return DEFAULT_HOME;
  const d = DEFAULT_HOME;
  const blocks = (Array.isArray(pub.blocks) ? pub.blocks : []).filter((b) => isObj(b) && typeof b.id === "string" && BLOCK_TYPE_LABELS[b.type]
    && (b.type === "ad" ? typeof b.image_url === "string" : Array.isArray(b.type === "columns" ? b.columns : b.items)));
  const keys = [...CORE_KEYS, ...blocks.map((b) => b.id)];
  const raw = Array.isArray(pub.sections_order) ? pub.sections_order.filter((k) => keys.includes(k)) : [];
  const order = new Set(raw).size === raw.length && CORE_KEYS.every((k) => raw.includes(k)) ? [...raw, ...keys.filter((k) => !raw.includes(k))] : keys;
  const rawItems = Array.isArray(pub.pillars?.items) ? pub.pillars.items : [];
  const items = d.pillars.items.map((di) => pick(di, rawItems.find((i) => isObj(i) && i.key === di.key)));
  const hero = pick(d.hero, pub.hero);
  if (!hero.title.trim()) hero.title = d.hero.title;
  const featured = pick(d.featured, pub.featured);
  featured.max_items = Number.isInteger(featured.max_items) && featured.max_items >= 1 && featured.max_items <= 12 ? featured.max_items : d.featured.max_items;
  return {
    sections_order: order,
    hero,
    pillars: { ...pick(d.pillars, pub.pillars), items },
    categories: pick(d.categories, pub.categories),
    featured,
    blocks,
    seo: pick(d.seo, pub.seo),
  };
};
